module.exports = __webpack_public_path__ + "img/w4-b1.ad944065.jpg";